import { DataCache, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { OrgProfileResponse } from 'data/models/OrgProfileResponse';

export class OrgProfileCache extends DataCache {
    OrgProfileResponses = PCCollection(OrgProfileResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship   (this.OrgProfileResponses, data.Organizations,     r => r.Organization, null);
        new QueryResultsRelationship(this.OrgProfileResponses, data.PierGroups,        r => r.PierGroups);
        new QueryResultsRelationship(this.OrgProfileResponses, data.Ports,             r => r.Ports);
        new QueryResultsRelationship(this.OrgProfileResponses, data.DefaultImages,     r => r.Ref && r.Ref.DefaultImages);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/orgprofile/cache.ts